var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.fieldMetaData
    ? _c("div", { staticClass: "general-view-tab row fullwidth" }, [
        _c(
          "div",
          { staticClass: "small-8 columns general-view-tab-left" },
          [
            _c("TextField", {
              attrs: {
                id: "modules-tenders-view-general-projectDescription",
                metaData: _vm.fieldMetaData.projectDescription,
                readonly: true,
                required: true,
              },
            }),
            _vm._v(" "),
            _c("TextField", {
              attrs: {
                id: "modules-tenders-view-general-projectLocation",
                metaData: _vm.fieldMetaData.projectLocation,
                readonly: true,
                required: true,
              },
            }),
            _vm._v(" "),
            _c("TextField", {
              attrs: {
                id: "modules-tenders-view-general-projectStart",
                metaData: _vm.fieldMetaData.projectStart,
                readonly: true,
                required: true,
              },
            }),
            _vm._v(" "),
            _c("TextField", {
              attrs: {
                id: "modules-tenders-view-general-estimatedProjectDuration",
                metaData: _vm.fieldMetaData.estimatedProjectDuration,
                readonly: true,
                required: true,
              },
            }),
            _vm._v(" "),
            _vm.shouldShowClosingDate || _vm.shouldShowClosingDateExtended
              ? _c(
                  "div",
                  { staticClass: "row closing-date-extension align-bottom" },
                  [
                    _vm.shouldShowClosingDate
                      ? _c("TextField", {
                          staticClass: "small-4 medium-4 large-4",
                          attrs: {
                            id: "modules-tenders-view-general-closingDate",
                            metaData: _vm.fieldMetaData.closingDate,
                            readonly: true,
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.shouldShowClosingDateExtended
                      ? _c("TextField", {
                          attrs: {
                            id: "modules-tenders-view-general-closingDateExtended",
                            metaData: _vm.fieldMetaData.closingDateExtended,
                            readonly: true,
                            hideLabel: true,
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("working-hours", {
              attrs: {
                id: "modules-tenders-view-general-workingHours",
                metaData: _vm.fieldMetaData.workingHours,
                readonly: true,
              },
            }),
            _vm._v(" "),
            _c("working-hours", {
              attrs: {
                id: "modules-tenders-view-general-noisyWorkingHours",
                metaData: _vm.fieldMetaData.noisyWorkingHours,
                readonly: true,
              },
            }),
            _vm._v(" "),
            _c("TextField", {
              attrs: {
                id: "modules-tenders-edit-general-specialWorkingHours",
                metaData: _vm.fieldMetaData.specialWorkingHours,
                readonly: true,
                required: false,
              },
            }),
            _vm._v(" "),
            _c("TextField", {
              attrs: {
                id: "modules-tenders-edit-general-paymentTerms",
                metaData: _vm.fieldMetaData.paymentTerms,
                readonly: true,
                required: false,
              },
            }),
            _vm._v(" "),
            _c("TextField", {
              attrs: {
                id: "modules-tenders-view-general-validityPeriod",
                metaData: _vm.fieldMetaData.validityPeriod,
                readonly: true,
              },
            }),
            _vm._v(" "),
            _c("TextField", {
              attrs: {
                id: "modules-tenders-view-general-onsiteVisit",
                metaData: _vm.fieldMetaData.onsiteVisitRequired,
                readonly: true,
              },
            }),
            _vm._v(" "),
            _vm.shouldShowAdditionalItems
              ? _c("label", { staticClass: "optional-label" }, [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("tender.general.optionalItems")) +
                      ":\n    "
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "ul",
              { staticClass: "additionalItems-list" },
              [
                _vm._l(_vm.optionalItems, function (option, index) {
                  var _obj
                  return [
                    option.selected
                      ? _c(
                          "li",
                          {
                            key: option.name,
                            staticClass: "row",
                            class:
                              ((_obj = {}),
                              (_obj[_vm.addendumClassName] =
                                _vm.isOptionalItemRevised(index)),
                              _obj),
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "ssmall-4 medium-4 large-4" },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(option.name) +
                                    "\n          "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "ssmall-7 medium-7 large-7" },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.formatDecimal(option.value)) +
                                    " " +
                                    _vm._s(option.text) +
                                    "\n          "
                                ),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                }),
              ],
              2
            ),
            _vm._v(" "),
            _vm.general.conditionsOfContracts
              ? _c(
                  "div",
                  {
                    staticClass: "text-field coc-items",
                    class:
                      ((_obj = {}),
                      (_obj[_vm.addendumClassName] =
                        _vm.isConditionsOfContractsRevised),
                      _obj),
                  },
                  [
                    _c("label", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("tender.general.conditionsOfContracts.label")
                        ) + ":"
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.cocI18nValue
                      ? [
                          _c("pre", {
                            domProps: {
                              innerHTML: _vm._s(_vm.conditionOfContractsHtml),
                            },
                          }),
                        ]
                      : _vm._e(),
                  ],
                  2
                )
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "small-4 columns general-view-tab-right" },
          [
            !_vm.isContractor
              ? _c(
                  "div",
                  [
                    _c("TextField", {
                      attrs: {
                        id: "modules-tenders-view-general-prNumber",
                        metaData: _vm.fieldMetaData.prNumber,
                        readonly: true,
                      },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "text-field" }, [
                      _c("label", { staticClass: "budget-label" }, [
                        _vm._v(
                          _vm._s(_vm.$t("tender.general.estimatedBudget")) +
                            ": "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("pre", [
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm._f("formatCurrency")(_vm.budget, {
                                currencyCode: _vm.currencyCode,
                              })
                            )
                          ),
                        ]),
                      ]),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("TextField", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.isContractor,
                  expression: "!isContractor",
                },
              ],
              attrs: {
                id: "modules-tenders-view-general-creator",
                metaData: _vm.fieldMetaData.creator,
                readonly: true,
              },
            }),
            _vm._v(" "),
            _c("TextField", {
              attrs: {
                id: "modules-tenders-view-general-manager",
                metaData: _vm.fieldMetaData.manager,
                readonly: true,
              },
            }),
            _vm._v(" "),
            _vm.isContractor
              ? _c("div", { staticClass: "text-field" }, [
                  _c("label", { staticClass: "site-label" }, [
                    _vm._v(_vm._s(_vm.$t("general.phone")) + ": "),
                  ]),
                  _vm._v(" "),
                  _c("pre", [_c("p", [_vm._v(_vm._s(_vm.picPhone || "--"))])]),
                  _vm._v(" "),
                  _c("label", { staticClass: "site-label" }, [
                    _vm._v(_vm._s(_vm.$t("general.email")) + ": "),
                  ]),
                  _vm._v(" "),
                  _c("pre", [_c("p", [_vm._v(_vm._s(_vm.picEmail || "--"))])]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.showApprover
              ? _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.isContractor,
                        expression: "!isContractor",
                      },
                    ],
                  },
                  [
                    _c("TextField", {
                      attrs: {
                        id: "modules-tenders-view-general-approver",
                        metaData: _vm.fieldMetaData.approver,
                        readonly: true,
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "text-field" }, [
              _c("label", { staticClass: "site-label" }, [
                _vm._v(_vm._s(_vm.$t("tender.general.siteId")) + ": "),
              ]),
              _vm._v(" "),
              _c("pre", [_c("p", [_vm._v(_vm._s(_vm.site))])]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.isContractor &&
                      _vm.deep(
                        _vm.fieldMetaData,
                        "onsiteVisitRequired.value"
                      ) === _vm.$i18n.t("yes"),
                    expression:
                      "isContractor && deep(fieldMetaData,'onsiteVisitRequired.value')=== $i18n.t('yes')",
                  },
                ],
                staticClass: "onsite-info",
              },
              [
                _c("label", { staticClass: "label-bold location-label" }, [
                  _vm._v(_vm._s(_vm.$t("tender.general.onSiteLocation"))),
                ]),
                _vm._v(" "),
                _c("pre", [
                  _vm._v(
                    _vm._s(_vm.deep(_vm.fieldMetaData, "onsiteLocation.value"))
                  ),
                ]),
                _vm._v(" "),
                _c("label", { staticClass: "label-bold" }, [
                  _vm._v(_vm._s(_vm.$t("tender.general.onSiteContact"))),
                ]),
                _vm._v(" "),
                _c("pre", [
                  _vm._v(
                    _vm._s(
                      _vm.deep(_vm.fieldMetaData, "onsiteContact.value.name")
                    )
                  ),
                ]),
                _vm._v(" "),
                _c("pre", [
                  _vm._v(
                    _vm._s(
                      _vm.deep(_vm.fieldMetaData, "onsiteContact.value.email")
                    )
                  ),
                ]),
                _vm._v(" "),
                _c("pre", [
                  _vm._v(
                    _vm._s(
                      _vm.deep(_vm.fieldMetaData, "onsiteContact.value.phone")
                    )
                  ),
                ]),
                _vm._v(" "),
                _c("label", { staticClass: "label-bold" }, [
                  _vm._v(_vm._s(_vm.$t("vendor.onSiteVisitDateTime"))),
                ]),
                _vm._v(" "),
                _c("pre", [_vm._v(_vm._s(_vm.visitDate))]),
              ]
            ),
            _vm._v(" "),
            _vm.bids && !_vm.isContractor
              ? _c("div", [
                  _c(
                    "label",
                    {
                      staticClass: "vendor-label",
                      attrs: { for: "tender.general.invitedVendors" },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("tender.general.vendors")) +
                          " (" +
                          _vm._s(_vm.bids ? _vm.bids.length : "-") +
                          "):\n      "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "ul",
                    { staticClass: "vendor-list" },
                    _vm._l(_vm.bids, function (bid) {
                      return _c(
                        "li",
                        { key: bid.id },
                        [
                          _c(
                            "HoverTooltip",
                            {
                              attrs: {
                                content: bid.company.name || "",
                                url: _vm.hoverTooltipMail(bid.vendorId),
                              },
                            },
                            [
                              _vm.invitedVendorDetails[bid.vendorId]
                                ? [
                                    _c("div", [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.invitedVendorDetails[
                                              bid.vendorId
                                            ]["contactAdmin"]
                                          ) +
                                          "\n              "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", [
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: _vm.hoverTooltipMail(
                                              bid.vendorId
                                            ),
                                            target: "_top",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.invitedVendorDetails[
                                                  bid.vendorId
                                                ]["username"]
                                              ) +
                                              "\n                "
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.invitedVendorDetails[
                                              bid.vendorId
                                            ]["contactPhone"]
                                          ) +
                                          "\n              "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.hoverTooltipHintWord(
                                              bid.vendorId
                                            )
                                          ) +
                                          "\n              "
                                      ),
                                    ]),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          ),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                ])
              : _vm._e(),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }